// export const monacoTheme = 'vs-light';
// export const monacoTheme = 'vs-dark';
// export const monacoTheme = "solarized-dark";
export const monacoTheme = "monokai";

